//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
export default {
  name: "SearchBox",
  data(){
    return {
        search: ""
    }
  },
  computed: {
    ...mapActions(["searchTvShows"])
  },
  methods: {
    searchItem(search) {
      this.$store.dispatch("searchTvShows", search);
      this.$router.push({ name: "search", params: { q: search } });
    }
  }
};
